import { SettingsIcon } from '@/components/icons';
import { Link, useLocation } from 'react-router';
import { ROUTES } from '@/app/router/routes';
import { cn } from '@/lib/utils/cn';
import { isModuleActive, NAV_ITEMS } from './navigation';
import './Sidebar.css';

export const Sidebar = () => {
  const { pathname } = useLocation();

  return (
    <aside className="platform-sidebar">
      <nav aria-label="Navigation principale" className="platform-sidebar-nav">
        {NAV_ITEMS.map(({ label, to, icon: Icon }) => {
          const active = isModuleActive(pathname, to);

          return (
            <Link
              key={to}
              to={to}
              aria-label={label}
              title={label}
              aria-current={active ? 'page' : undefined}
              className={cn('sidebar-nav-item', active && 'sidebar-nav-item--active')}
            >
              <Icon className="sidebar-nav-icon" />
            </Link>
          );
        })}
      </nav>
      <nav aria-label="Configuration" className="platform-sidebar-footer">
        <Link
          to={ROUTES.settings}
          title="Paramètres"
          aria-label="Paramètres"
          aria-current={pathname.startsWith('/parametres') ? 'page' : undefined}
          className={cn(
            'sidebar-nav-item',
            pathname.startsWith('/parametres') && 'sidebar-nav-item--active',
          )}
        >
          <SettingsIcon className="sidebar-nav-icon" />
        </Link>
      </nav>
    </aside>
  );
};
